import {
  panelContainer,
  panelSubHeader,
  scoreboardValueVariants,
} from "./scoreboardPanel.css";
import { ScoreboardPanelProps } from "./types";

const ScoreboardPanel = ({
  status = "default",
  value,
  header,
}: ScoreboardPanelProps) => (
  <div className={panelContainer} role="status" aria-atomic="true">
    <h3 className={panelSubHeader}>{header}</h3>
    <div>
      <div className={scoreboardValueVariants[status]}>{value}</div>
    </div>
  </div>
);

export default ScoreboardPanel;
